import type { FunctionComponent, ReactElement } from 'react'
import React, { createContext, useContext } from 'react'

export type IMainLayoutContext = {
  newsLetterFooter?: ReactElement
  contactFooter?: ReactElement
}
const MainLayoutContext = createContext({} as IMainLayoutContext)

export const MainLayoutContextProvider: FunctionComponent<
  React.PropsWithChildren<{
    context: IMainLayoutContext
  }>
> = ({ children, context }) => {
  return (
    <MainLayoutContext.Provider value={context}>
      {children}
    </MainLayoutContext.Provider>
  )
}

export const useMainLayoutContext = () => {
  return useContext(MainLayoutContext)
}
